module.exports = __webpack_public_path__ + "fonts/d121b5f.otf";